import { newsBriefs } from "@/mocks/homeContent";
import SectionHeading from "./SectionHeading";

export default function NewsBriefList() {
  return (
    <section id="briefs" className="scroll-mt-20">
      <SectionHeading
        eyebrow="爆料速递"
        title="标题 + 短摘要，一屏扫完最新八条"
        desc="短讯与卡片并行呈现，黑料学生爆料有任何新进展都会在这里即时补充，点开就能看到关键信息。"
        action={{ label: "查看全部速递", href: "#briefs" }}
      />

      <div className="divide-y divide-background-200/70 overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
        {newsBriefs.map((item) => (
          <a
            key={item.id}
            href="#briefs"
            className="group block cursor-pointer p-4 transition-colors hover:bg-background-100 md:p-5"
          >
            <div className="mb-2 flex flex-wrap items-center gap-x-3 gap-y-1.5">
              <span className="inline-flex items-center rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-900">
                {item.tag}
              </span>
              <span className="text-[11px] text-foreground-400">{item.time}</span>
              <span className="hidden text-[11px] text-foreground-400 sm:inline">
                来源 · {item.source}
              </span>
            </div>
            <h3 className="text-[15px] font-semibold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
              {item.title}
            </h3>
            <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600 md:text-sm">
              {item.summary}
            </p>
            <div className="mt-2.5 flex items-center gap-4 text-[11px] text-foreground-400">
              <span className="flex items-center gap-1">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-chat-3-line text-xs"></i>
                </span>
                {item.comments} 条讨论
              </span>
              <span className="flex items-center gap-1">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-share-forward-line text-xs"></i>
                </span>
                转发
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}